export enum InstallationSchemaPropertyType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  SELECT = 'select',
  DATE = 'date',
  INTEGER = 'integer',
  NUMBER = 'number',
  OBJECT = 'object',
  ARRAY = 'array',
}
